import { useEffect } from "react";
import { useGlobalContext } from "./Context"
import LoadingIcon from "./Components/LoadingIcon";
import PremisesList from "./Components/PremisesList";
import { Typography, Col, Row } from 'antd';

const ShameList = () => {
    const { shameList, retrieveShameList, loading } = useGlobalContext();

    useEffect(() => {
        retrieveShameList();
    });

    if (loading) {
        return (
            <Row>
                <Col span={24}>
                    <div className="row d-flex justify-content-center align-items-center">
                        <LoadingIcon />
                    </div>
                </Col>
            </Row>

        )
    }

    return (
        <>
            <Row style={{marginTop: "10px"}}>
                <Col span={24}>
                    <Typography.Title level={4}>Auckland's latest filthy restaurants</Typography.Title>
                </Col>
            </Row>            
            <Row>
                <Col span={24}>
                    <PremisesList premises={shameList} isFromSearch={false}/>
                </Col>
            </Row>
        </>
    );
}

export default ShameList;
